<template>
  <v-app id="inspire">
    <v-app id="inspire">
      <v-navigation-drawer
        hide-overlay
        v-model="drawer"
        width="326"
        app
        @transitionend="transitionend"
      >
        <NavigationLabel />
        <div class="text-center pb-1" v-if="loading">
          <double-bounce></double-bounce>
        </div>
        <div class="text-center pb-2 pt-1" v-else>
          <v-chip class="ma-1"> A: {{ totalApartment }} </v-chip>
          <v-chip class="ma-1"> O: {{ totalOffice }} </v-chip>
          <v-chip class="ma-1">H: {{ totalHotel }}</v-chip>
          <v-chip class="ma-1"> R: {{ totalRetail }} </v-chip>
          <v-chip class="ma-1">OT: {{ totalOther }}</v-chip>
        </div>
        <v-divider></v-divider>
        <div v-if="showInner">
          <div class="mb-5 inner-type text-center">
            <h3 style="font-weight: bold">Choose filter type:</h3>
          </div>
          <div class="text-center mt-5 mb-4">
            <v-btn @click="(showMulti = true), (showInner = false)" small
              >Single Location</v-btn
            >
          </div>
          <div v-if="!isClient()" class="text-center mt-4 mb-3">
            <h4>OR</h4>
          </div>
          <div v-if="!isClient()" class="text-center mt-3 mb-4">
            <v-btn
              @click="(showSingle = true), (showInner = false)"
              small
              color="primary"
              >Multi Location</v-btn
            >
          </div>
        </div>

        <!-- Multi Location -->
        <div class="pl-4 pr-4 pt-5 pb-4" v-if="showSingle">
          <!-- Detail Building -->
          <BuildingDetail />
          <!-- End Detail Building -->

          <p v-if="district.length < 1" class="p-location">Pilih Lokasi</p>
          <p v-else class="p-location">
            <v-badge color="brown" inline :content="district.length">
              Pilih Lokasi
            </v-badge>
          </p>
          <v-list-item v-for="(list, i) in listDistrict" :key="i">
            <v-checkbox
              :label="list.name"
              :value="list.value"
              v-model="district"
              @change="filterDataType('district_subdistrict', $event)"
              hide-details
            ></v-checkbox>
          </v-list-item>
          <div class="px-4 pt-4">
            <v-dialog
              v-model="menuRegion"
              :close-on-content-click="false"
              :nudge-width="200"
              width="360"
              offset-x
              scrollable
            >
              <template v-slot:activator="{ on, attrs }">
                <a href="#" v-bind="attrs" v-on="on" class="green--text">
                  Lihat Selengkapnya
                </a>
              </template>

              <v-card height="500">
                <v-card-title>Select Location</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-text-field
                    class="mt-4 mb-4"
                    v-model="searchLocation"
                    @input="onChangeSearch($event)"
                    label="Search Location"
                    outlined
                    hide-details
                  ></v-text-field>
                  <div class="text-center pb-1" v-if="loadingSearchLocation">
                    <double-bounce></double-bounce>
                  </div>
                  <div v-else>
                    <div
                      v-if="
                        listDistrictSearch.length < 1 &&
                          listSubdistrictSearch.length < 1
                      "
                      class="text-center pt-4"
                    >
                      <h3>Not Found</h3>
                    </div>
                    <div v-else>
                      <div class="pt-4">
                        <h3 class="font-weight-bold mb-0">District</h3>
                        <v-list-item
                          v-for="(list, i) in listDistrictSearch"
                          :key="i"
                        >
                          <v-checkbox
                            :label="list"
                            :value="list"
                            v-model="district"
                            @change="
                              filterDataType('district_subdistrict', $event)
                            "
                            hide-details
                          ></v-checkbox>
                        </v-list-item>
                      </div>
                      <div class="pt-2">
                        <h3 class="font-weight-bold mb-0 pt-4">Sub District</h3>
                        <v-list-item
                          v-for="(list, i) in listSubdistrictSearch"
                          :key="i"
                        >
                          <v-checkbox
                            :label="list"
                            :value="list"
                            v-model="district"
                            @change="
                              filterDataType('district_subdistrict', $event)
                            "
                            hide-details
                          ></v-checkbox>
                        </v-list-item>
                      </div>
                    </div>
                  </div>
                </v-card-text>

                <v-card-actions>
                  <v-btn color="blue darken-1" text @click="menuRegion = false"
                    >Submit</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <div class="pt-4">
            <v-btn
              @click="exportData"
              class="mb-2"
              color="success"
              depressed
              block
              v-if="reporting == false"
            >
              download report
            </v-btn>
            <v-btn @click="handleReset" color="primary" depressed block>
              reset
            </v-btn>
          </div>
        </div>

        <!-- Single Location -->
        <div class="pl-4 pr-4 pt-4 pb-4" v-if="showMulti">
          <v-form>
            <v-list>
              <!-- Region / Location -->
              <gmap-autocomplete
                @place_changed="filterDataType('region', $event)"
                :select-first-on-enter="true"
              >
                <template v-slot:input="slotProps">
                  <v-text-field
                    class="mb-5"
                    ref="input"
                    placeholder="Type a location or Region"
                    outlined
                    v-on:listeners="slotProps.listeners"
                    v-on:attrs="slotProps.attrs"
                    label="Type a location or Region"
                    prepend-inner-icon="mdi-map-marker"
                    v-model="region"
                    @input="filterDataType('region', $event)"
                    hide-details
                  >
                  </v-text-field>
                </template>
              </gmap-autocomplete>

              <!-- Places Detail -->
              <PlaceDetail :placeDetail="placeDetail" />
              <!-- End Places Detail -->

              <!-- Detail Building -->
              <BuildingDetail />
              <!-- End Detail Building -->

              <!-- End Region / Location -->
              <v-card class="mb-4 pb-2">
                <!-- Building Type -->
                <NavigationBuildingType />
                <!-- End Building Type -->
                <!-- Instalation -->
                <NavigationInstallation v-if="reporting == false" />
                <!-- End Instalation -->
                <!-- Screen Type -->
                <v-list-group v-if="reporting == false">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>Screen Type</v-list-item-title>
                    </v-list-item-content>
                    <div v-if="screenType.length > 0">
                      <v-badge color="brown" :content="screenType.length">
                      </v-badge>
                    </div>
                  </template>
                  <v-list-item
                    v-for="(list, i) in listScreenTypes.slice(0, 4)"
                    :key="i"
                  >
                    <v-checkbox
                      :label="list.name"
                      :value="`${JSON.stringify(list)}`"
                      v-model="screenType"
                      @change="filterDataType('screen_type', $event)"
                      hide-details
                    ></v-checkbox>
                  </v-list-item>
                  <div class="px-4 pt-4">
                    <v-dialog
                      v-model="menuScreenType"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      width="360"
                      scrollable
                      offset-x
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <a
                          href="#"
                          v-bind="attrs"
                          v-on="on"
                          class="green--text"
                        >
                          Lihat Selengkapnya
                        </a>
                      </template>

                      <v-card height="500">
                        <v-card-title>Select Screen Type</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-text-field
                            class="mt-4 mb-4"
                            v-model="searchScreenType"
                            @input="onChangeSearchScreenType($event)"
                            label="Search Screen Type"
                            outlined
                            hide-details
                          ></v-text-field>
                          <div
                            class="text-center pb-1"
                            v-if="loadingScreenTypeLocation"
                          >
                            <double-bounce></double-bounce>
                          </div>
                          <div v-else>
                            <div
                              v-if="listScreenTypeSearch < 1"
                              class="text-center pt4-"
                            >
                              <h3>Not Found</h3>
                            </div>
                            <div v-else>
                              <div class="pt-4">
                                <h3 class="font-weight-bold mb-0">
                                  Screen Type
                                </h3>
                                <v-list-item
                                  v-for="(list, i) in listScreenTypeSearch"
                                  :key="i"
                                >
                                  <v-checkbox
                                    :label="list.name"
                                    :value="`${JSON.stringify(list)}`"
                                    v-model="screenType"
                                    @change="
                                      filterDataType('screen_type', $event)
                                    "
                                    hide-details
                                  ></v-checkbox>
                                </v-list-item>
                              </div>
                            </div>
                          </div>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="menuScreenType = false"
                            >Submit</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </v-list-group>
                <!-- End Screen Type -->
                <!-- Progress -->
                <v-list-group v-if="reporting == false">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>Progress</v-list-item-title>
                    </v-list-item-content>
                    <div v-if="progress.length > 0">
                      <v-badge color="brown" :content="progress.length">
                      </v-badge>
                    </div>
                  </template>
                  <v-list-item v-for="(list, i) in listProgress" :key="i">
                    <v-checkbox
                      :label="list.name"
                      :value="list.value"
                      v-model="progress"
                      @change="filterDataType('progress', $event)"
                      hide-details
                    ></v-checkbox>
                  </v-list-item>
                </v-list-group>
                <!-- End Progress -->
                <!-- LCD Presence -->
                <v-list-group v-if="reporting == false">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>LCD Presence</v-list-item-title>
                    </v-list-item-content>
                    <div v-if="lcdPresence.length > 0">
                      <v-badge color="brown" :content="lcdPresence.length">
                      </v-badge>
                    </div>
                  </template>
                  <v-list-item v-for="(list, i) in listLcdPresence" :key="i">
                    <v-checkbox
                      :label="list"
                      :value="list"
                      v-model="lcdPresence"
                      @change="filterDataType('lcd_presence', $event)"
                      hide-details
                    ></v-checkbox>
                  </v-list-item>
                </v-list-group>
                <!-- End LCD Presence -->
                <!-- Building Grade & Star -->
                <v-list-group v-if="reporting == false">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>Building Grade</v-list-item-title>
                    </v-list-item-content>
                    <div v-if="buildingGrade.length > 0">
                      <v-badge color="brown" :content="buildingGrade.length">
                      </v-badge>
                    </div>
                  </template>
                  <v-list-item
                    v-for="(list, i) in listBuildingGrade.slice(0, 4)"
                    :key="i"
                  >
                    <v-checkbox
                      v-model="buildingGrade"
                      :label="list.name"
                      :value="list.value"
                      @change="filterDataType('building_grade', $event)"
                      hide-details
                    ></v-checkbox>
                  </v-list-item>
                  <div class="px-4 pt-4">
                    <v-dialog
                      v-model="menuBuildingGrade"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      width="360"
                      scrollable
                      offset-x
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <a
                          href="#"
                          v-bind="attrs"
                          v-on="on"
                          class="green--text"
                        >
                          Lihat Selengkapnya
                        </a>
                      </template>

                      <v-card height="500">
                        <v-card-title>Select Building Grade</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-list-item
                            v-for="(list, i) in listBuildingGrade"
                            :key="i"
                          >
                            <v-checkbox
                              v-model="buildingGrade"
                              :label="list.name"
                              :value="list.value"
                              @change="filterDataType('building_grade', $event)"
                              hide-details
                            ></v-checkbox>
                          </v-list-item>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="menuBuildingGrade = false"
                            >Submit</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                  <div class="pb-3"></div>
                </v-list-group>
                <v-list-group v-if="reporting === false && accessAnalytics()">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>Point of Interest</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item>
                    <v-autocomplete
                      label="Point of Interest"
                      :items="potentialClients"
                      item-value="id"
                      item-text="name"
                      v-model="places"
                      @input="selectPotentialClients"
                    ></v-autocomplete>
                  </v-list-item>
                </v-list-group>
                <!-- End Building Grade & Star -->
                <v-divider></v-divider>
                <!-- Year -->
                <v-subheader v-if="reporting == false"
                  >Year {{ year[0] }} - {{ year[1] }}</v-subheader
                >
                <v-range-slider
                  v-if="reporting == false"
                  v-model="year"
                  :max="max"
                  :min="min"
                  class="pr-3 pl-3"
                  @change="filterDataType('year', $event)"
                />
                <!-- End Year -->
                <v-divider></v-divider>
                <!-- Radius -->
                <v-subheader>Radius {{ radius }} kilometer</v-subheader>
                <v-slider
                  v-model="radius"
                  step="1"
                  min="0"
                  :max="maxRadius"
                  class="pr-3 pl-3"
                  @change="filterDataType('radius', $event)"
                ></v-slider>
                <!-- End Radius -->
              </v-card>
            </v-list>

            <v-btn
              @click="exportData"
              class="mb-2"
              color="success"
              depressed
              block
              v-if="reporting == false"
            >
              download report
            </v-btn>
            <v-btn
              class="mb-4"
              @click="handleReset"
              color="primary"
              depressed
              block
            >
              reset
            </v-btn>
            <v-btn
              @click="backToDashboard"
              color="primary"
              depressed
              block
              dark
            >
              Back to dashboard
            </v-btn>
          </v-form>
        </div>
        <div class="btn-bottom text-center" v-if="showInner">
          <v-divider></v-divider>
          <div class="pt-5" v-if="reporting">
            <v-btn @click="backToDashboard"
              ><v-icon>mdi-login-variant</v-icon> Back to Dashboard</v-btn
            >
          </div>
          <div class="pt-5">
            <v-btn @click="logout"
              ><v-icon>mdi-login-variant</v-icon> Logout</v-btn
            >
          </div>
        </div>
      </v-navigation-drawer>
      <v-main>
        <GoogleMaps />
        <v-btn
          v-if="$vuetify.breakpoint.mdAndDown"
          @click="drawer = true"
          class="float-button ma-2 white--text"
          color="primary"
          fab
        >
          <v-icon dark>mdi-magnify</v-icon>
        </v-btn>
      </v-main>
    </v-app>
  </v-app>
</template>

<script>
import NavigationLabel from "./components/NavigationLabel";
import NavigationBuildingType from "./components/NavigationBuildingType";
import NavigationInstallation from "./components/NavigationInstallation";
import BuildingDetail from "./components/BuildingDetail";
import PlaceDetail from "./components/PlaceDetail";
import GoogleMaps from "./components/GoogleMaps";
import axios from "@/plugins/axios";
import { EventBus } from "@/utils/eventBus";
import { debounce } from "@/utils/format";
import { DoubleBounce } from "vue-loading-spinner";
import { removeToken, getToken } from "./utils/auth";
import jsonData from "./utils/data.json";
import { saveAs } from "file-saver";
import * as dayjs from 'dayjs'

export default {
  components: {
    GoogleMaps,
    PlaceDetail,
    NavigationLabel,
    NavigationBuildingType,
    NavigationInstallation,
    DoubleBounce,
    BuildingDetail
  },
  name: "MapApp",
  data() {
    let currentYear = new Date().getFullYear();

    return {
      reporting: false,
      reset: false,
      showInner: true,
      showSingle: false,
      showMulti: false,
      loading: false,
      totalApartment: 0,
      totalHotel: 0,
      totalOffice: 0,
      totalRetail: 0,
      totalOther: 0,
      menuLcdPresence: false,
      menuScreenType: false,
      menuRegion: false,
      menuBuildingGrade: false,
      min: 1980,
      max: currentYear,
      drawer: true,
      region: [],
      potentialClients: [],
      district: [],
      subdistrict: [],
      buildingName: [],
      progress: [],
      year: [1980, 2020],
      radius: 0,
      maxRadius: 200,
      listScreenTypes: [],
      listRegion: [],
      listDistrict: jsonData.listDistrict,
      listDistrictSearch: [],
      listScreenTypeSearch: [],
      listSubdistrict: [],
      listSubdistrictSearch: [],
      screenType: [],
      prescreen: [],
      lcdPresence: ["TMN"],
      buildingGrade: [],
      paramsExport: "?filter[lcd_presence]=TMN",
      loadingSearchLocation: false,
      loadingScreenTypeLocation: false,
      listLcdPresence: ["TMN", "FMI", "DFI", "Opportunities", "Other"],
      searchLocation: [],
      searchScreenType: [],
      listBuildingGrade: jsonData.listBuildingGrade,
      listProgress: jsonData.listProgress,
      places: "",
      placeDetail: {},
      buildings: []
    };
  },
  mounted() {
    if (getToken("role") == 12) {
      this.reporting = true;
    }

    this.loadScreenType();
    this.loadRegion();
    this.getStartYear();
    this.loadPotentialClients();
  },
  updated() {
    EventBus.$emit("TYPE_BACK_START", this.showInner);
  },
  created() {
    EventBus.$on("UPDATE_INPUT", value => {
      this.region = value;
    });

    EventBus.$on("CLOSE_PLACE_DETAIL", () => {
      this.placeDetail = {};
    });

    EventBus.$on("FETCH_CLIENT_PLACES", value => {
      this.placesSelected(value);
    });

    EventBus.$on("TYPE_EXPORT", params => {
      this.paramsExport = params;
      // this.loadData();
    });

    EventBus.$on("TYPE_DETAIL_BUILDING", () => {
      const vm = this;
      setTimeout(() => {
        vm.$set(this, "drawer", true);
      }, 500);
    });

    EventBus.$on("TYPE_CLOSE_MAP", value => {
      this.buildingDetailShow = value;
    });

    EventBus.$on("UPDATE_DATA", data => {
      this.totalApartment = data.total_appartment;
      this.totalHotel = data.total_hotel;
      this.totalOffice = data.total_office;
      this.totalRetail = data.total_retail;
      this.totalOther = data.total_others;
      this.buildings = data.data;
    });
  },
  methods: {
    isClient() {
      return getToken("role") === 12;
    },
    accessAnalytics() {
      return getToken("mapping-analytics") === "1";
    },
    async loadPotentialClients() {
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("api_token")
      };
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/admin/potentialclient?rowsPerPage=1000`,
        { headers }
      );
      this.potentialClients = response.data.data.data;
    },
    placesSelected(value) {
      this.placeDetail = value;
    },
    selectPotentialClients(potentialClientId) {
      EventBus.$emit("SELECT_POTENTIAL_CLIENT", potentialClientId);
    },
    onChangeSearch: debounce(function(value) {
      this.loadingSearchLocation = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/admin/mapping-region?filter[district_subdistrict]=${value}`
        )
        .then(result => {
          this.loadingSearchLocation = false;
          this.listDistrictSearch = result.data.data.district;
          this.listSubdistrictSearch = result.data.data.subdistrict;
        })
        .catch(err => {
          throw new Error(err);
        });
    }, 1100),
    onChangeSearchScreenType: debounce(function(value) {
      this.loadingScreenTypeLocation = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/admin/mapping-screentype?filter[size]=${value}`
        )
        .then(result => {
          this.loadingScreenTypeLocation = false;
          this.listScreenTypeSearch = result.data.data;
        })
        .catch(err => {
          throw new Error(err);
        });
    }, 1100),
    async loadScreenType() {
      await axios
        .get(`${process.env.VUE_APP_API_URL}/api/admin/mapping-screentype`)
        .then(result => {
          this.listScreenTypes = result.data.data;
          this.listScreenTypeSearch = result.data.data;
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    async loadRegion() {
      await axios
        .get(`${process.env.VUE_APP_API_URL}/api/admin/mapping-region`)
        .then(result => {
          this.listDistrictSearch = result.data.data.district;
          this.listSubdistrict = result.data.data.subdistrict;
          this.listSubdistrictSearch = result.data.data.subdistrict;
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    async loadData() {
      this.loading = true;
      let url = "";

      if (this.paramsExport == "") {
        url = `${process.env.VUE_APP_API_URL}/api/admin/mapping-building?filter[lcd_presence]=TMN`;
      } else {
        url = `${process.env.VUE_APP_API_URL}/api/admin/mapping-building${this.paramsExport}`;
      }

      try {
        const token = getToken("api_token");
        const result = await axios.get(url, {
          headers: {
            Authorization: token
          }
        });
        this.loading = false;
        this.totalApartment = result.data.total_appartment;
        this.totalHotel = result.data.total_hotel;
        this.totalOffice = result.data.total_office;
        this.totalRetail = result.data.total_retail;
        this.totalOther = result.data.total_others;
      } catch (err) {
        throw new Error(err);
      }
    },
    filterDataType: debounce(function(type, value) {
      let data = {};
      if (type == "region") {
        data = {
          lat: value.geometry == undefined ? "" : value.geometry.location.lat(),
          lng: value.geometry == undefined ? "" : value.geometry.location.lng()
        };
      } else if (type == "radius") {
        data = value * 1000;
      } else {
        data = value;
      }

      EventBus.$emit("TYPE_EVENT", { type, data });
    }, 1000),
    exportData() {
      const ids = this.buildings.map(building => building.id);
      return axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/admin/mapping-building/export`,
          { ids },
          { responseType: "blob" }
        )
        .then(res => {
          const baseName = 'Target Media Nusantara - Mapping Building List - '
          const currentDay = dayjs().format('DD-MM-YYYY')
          saveAs(res.data, baseName + currentDay + '.xlsx');
        });
    },
    async handleReset() {
      this.district = [];
      this.subdistrict = [];
      this.screenType = [];
      this.progress = [];
      this.lcdPresence = [];
      this.buildingGrade = [];
      this.places = "";
      this.year = [this.min, 2020];
      this.radius = 0;

      let url = `${process.env.VUE_APP_API_URL}/api/admin/mapping-building/cache`;

      EventBus.$emit("RESET_POINT");

      await axios
        .get(url)
        .then(result => {
          this.loading = false;
          this.totalApartment = result.data.total_appartment;
          this.totalHotel = result.data.total_hotel;
          this.totalOffice = result.data.total_office;
          this.totalRetail = result.data.total_retail;
          this.totalOther = result.data.total_others;

          EventBus.$emit("TYPE_RESET", "reset");
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    async getStartYear() {
      let url = `${process.env.VUE_APP_API_URL}/api/admin/mapping-yearlist?sort=asc`;
      await axios
        .get(url)
        .then(result => {
          this.min = result.data.year[0];
          this.year = [this.min, this.max];
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    actionBack() {
      window.location.reload();
    },
    logout() {
      removeToken("mapping-analytics");
      removeToken("api_token");
      this.$router.push("/login");
    },
    backToDashboard() {
      window.location.reload();
    }
  }
};
</script>

<style scoped>
.float-button {
  position: absolute;
  bottom: 0;
}

.card-responsive {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 286px;
}

.p-location {
  margin-bottom: 0;
  font-weight: bold;
}

.inner-type {
  margin-top: 60px;
}

.btn-bottom {
  margin-top: 64px;
}

@media only screen and (min-width: 1366px) and (max-width: 1368px) {
  .card-responsive {
    min-height: 430px;
  }
}

@media only screen and (min-width: 1440px) and (max-width: 1920px) {
  .card-responsive {
    min-height: 368px;
  }
}
</style>
